export default __webpack_public_path__ + "static/frame@2x-02dfc4c5e4a3db4ea3002e7dbbf52688.png";